import { render, staticRenderFns } from "./AboutGallery.vue?vue&type=template&id=2f5a1d98&scoped=true&"
import script from "./AboutGallery.vue?vue&type=script&lang=js&"
export * from "./AboutGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a1d98",
  null
  
)

export default component.exports